"use client";

import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
import { Container, SectionSubHeading, SectionTitle } from "@/components";
import { serviceIndustries } from "@/data/ServiceIndustriesData";
import { cardRise, cardStagger, fadeInUp } from "@/lib/animation/variant";
const ServiceIndustries = () => {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      once: true
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <motion.div custom={0} initial="hidden" whileInView="visible" viewport={t0} variants={fadeInUp}><SectionSubHeading subtitle="Where the work lands" className="text-primary" /></motion.div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      once: true
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="space-y-2">{t1}<motion.div custom={1} initial="hidden" whileInView="visible" viewport={t2} variants={fadeInUp}><SectionTitle title="Expertise across the categories we ship in." className="text-white" /></motion.div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <motion.p custom={2} initial="hidden" whileInView="visible" viewport={{
      once: true
    }} variants={fadeInUp} className="max-w-3xl text-base leading-relaxed font-medium text-white/60 md:text-lg">The five stages do not change with the industry, but the research does. These are the categories we have already shipped into — and what each one taught us.</motion.p>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      once: true,
      amount: 0.15
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <section className="w-full rounded-4xl bg-accent-foreground py-20 md:py-28"><Container className="flex flex-col gap-8 px-4 lg:px-10">{t3}{t4}<motion.div initial="hidden" whileInView="show" viewport={t5} variants={cardStagger} className="mt-6 grid gap-5 md:grid-cols-2 xl:grid-cols-3">{serviceIndustries.map(_temp)}</motion.div></Container></section>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};
export default ServiceIndustries;
function _temp(industry) {
  return <motion.article key={industry.number} variants={cardRise} className="flex flex-col gap-3 rounded-2xl border border-white/15 p-6 md:p-7"><span className="font-mono text-[10px] tracking-[0.24em] text-primary">{industry.number}</span><h3 className="text-xl leading-tight font-black tracking-tighter text-white uppercase">{industry.title}</h3><p className="text-sm leading-relaxed text-white/60">{industry.description}</p><p className="mt-auto border-t border-white/15 pt-4 font-mono text-[9px] leading-loose tracking-[0.14em] text-white/45 uppercase">{industry.proof}</p></motion.article>;
}